import { Injectable } from '@angular/core'

@Injectable()
export class CopyFeedbackService {
  copiedStates: { [key: string]: boolean } = {}

  onCopied(key: string): void {
    this.copiedStates[key] = true
    setTimeout(() => {
      this.copiedStates[key] = false
    }, 2000)
  }
}
